import { ToastrService } from 'ngx-toastr';
import { ArticleBlock, ArticleImage } from '../../../../models/article';
import { Component, EventEmitter, Input, Output, TemplateRef, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { extractAttributeFromTag } from 'src/app/common/function';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'article-upload-image',
  templateUrl: './article-upload-image.component.html',
  styleUrls: ['./article-upload-image.component.scss'],
})
export class ArticleUploadImageComponent {
  @Output() blockElementChange = new EventEmitter<ArticleBlock>();
  @Output() onCancelBtn = new EventEmitter<ArticleBlock>();

  @Input() set blockElement(value: ArticleBlock) {
    this._blockElement = value;
    this.imageUrl = this.blockElement.originalImage;
    this.croppedImageUrl = JSON.parse(JSON.stringify(this.blockElement.data));
  }

  get blockElement() {
    return this._blockElement;
  }

  private _blockElement: ArticleBlock;

  imageUrl: string;
  selectedValue: number;
  imageChangedEvent: string = '';
  croppedImageUrl: any;
  scale = 1;
  aspectRatio: number;
  showCropper: boolean = false;
  containWithinAspectRatio: boolean = false;
  imageURL?: string;
  allowMoveImage: boolean = false;
  hidden: boolean = false;
  showCropOptions: boolean = false;
  croppedImage: any;

  aspectRatios = [
    { label: 'Letterbox', value: 16 / 9 },
    { label: 'Square', value: 1 / 1 },
    { label: '18:6', value: 18 / 6 },
    { label: '9:6', value: 9 / 6 },
    { label: '4:3', value: 4 / 3 },
  ];

  formGroup = new FormGroup({
    Image: new FormControl(''),
    Letterbox: new FormControl(true),
    Square: new FormControl(false),
    '18:6': new FormControl(false),
    '9:6': new FormControl(false),
    '4:3': new FormControl(false),
  });

  constructor(private sanitizer: DomSanitizer, private toastr: ToastrService) {
    this.selectedValue = this.aspectRatios[0].value;
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (!file.type?.startsWith("image/")) {
        this.toastr.error('Please select a image.');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.imageUrl = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  fileChangeEvent(event: string): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.blob;
    if (this.croppedImage) {
      this.blockElement.originalImage = this.imageUrl;
      this.blockElement.data = this.fileToBlobUrl(this.croppedImage);
    }
  }

  fileToBlobUrl(file) {
    const blob = new Blob([file], { type: file.type });
    return URL.createObjectURL(blob);
  }

  imageLoaded() {
    this.showCropper = true;
  }

  onChange(e: number) {
    this.selectedValue = e;
  }

  save(e: any) {
    this.croppedImageUrl = JSON.parse(JSON.stringify(this.blockElement.data));
    this.blockElement.images = [];
    this.blockElement.images.push({ image: this.croppedImage } as ArticleImage);
    this.blockElement.isActiveForEdit = false;
    this.blockElementChange.emit(this.blockElement);
    this.showCropOptions = false;
  }

  // get imageStyle() {
  //   return this.selectedValue.toFixed(2) == '1.78'
  //     ? `main-img latterbox`
  //     : 'main-img';
  // }
  private modalService = inject(NgbModal);

  openDiscardChangesModal(discardChangesModal: TemplateRef<any>, e: any) {
    const modalRef = this.modalService.open(discardChangesModal, {
      windowClass: 'delete-section-modal discard-changes-modal',
      centered: true,
      size: 'sm',
    });

    modalRef.result.then(
      (result) => {
        if (result) {
          this.close(e)
        }
      },
      (reason) => {
        // Handle modal dismissal or other reasons
      }
    );
  }

  close(e: any) {
    this.blockElement.data = this.croppedImageUrl;
    if (this.blockElement.data) {
      this.blockElement.isActiveForEdit = false;
    }
    this.onCancelBtn.emit(this.blockElement);
    this.croppedImageUrl = '';
    this.showCropOptions = false;
  }
}
